import { useContext } from 'react';
import ReactDom from 'react-dom';

import styled from '@emotion/styled';

import { ModalContext } from '../../Context/ModalContext';

interface IModal {
  children: React.ReactNode;
}

export const Modal: React.FC<IModal> = ({ children }) => {
  const modalRoot = document.getElementById('modal-root');
  const modalContext = useContext(ModalContext);

  return ReactDom.createPortal(
    <ModalContainer className={modalContext?.showModal ? '' : 'closeModal'}>
      {children}
    </ModalContainer>,
    modalRoot!
  );
};

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  isolation: isolate;
  background: rgba(217, 217, 217, 0.5);
  backdrop-filter: blur(4px);
  display: grid;
  place-content: center;

  &.closeModal {
    display: None;
  }
`;
